import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../../environments/environment";
import {Observable} from "rxjs";
import {
  GetDuplicateClaimsDto
} from "../../../../auto-generated-server-dtos/adjuster/claim/duplicate-detection/get-duplicate-claims-dto";

@Injectable({
  providedIn: 'root'
})
export class GetDuplicateClaimsService {
  constructor(private httpClient: HttpClient) {
  }

  getDuplicateClaims(claimId: number) {
    return this.httpClient.get<GetDuplicateClaimsDto>(`${environment.apiServer}/Adjuster/Claim/GetDuplicateClaims`, {params: {claimId: claimId}});
  }
}
